import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Visit } from 'src/app/admin/models/visit.model';
import { VisitService } from 'src/app/admin/services/visit.service';
import { environment } from 'src/environments/environment';
import * as signalR from "@microsoft/signalr";
import { Visiti } from 'src/app/admin/models/visiti.model';

@Component({
  selector: 'app-edit-visit-modal',
  templateUrl: './edit-visit-modal.component.html',
  styleUrls: ['./edit-visit-modal.component.scss'],
})
export class EditVisitModalComponent implements OnInit {
  visitId: number;
  visit: Visit;
  errMsg = '';
  msg = '';
  apiUrl = environment.apiUrl;
  visits$ = this.visitService.visit$;
  roomId;
  qrCode = '';

  constructor(private modalController: ModalController, private visitService: VisitService) {}

  ngOnInit() 
  {
    // TODO: user from AccountService, MM
     let loggedUser = JSON.parse(localStorage.getItem('loggedUser'));
    this.roomId = loggedUser.roomId;
    this.visitService.getVisitById(this.visitId).subscribe(result => {
      this.visit = result as Visit;
      this.qrCode = this.visit.cardId.toString();
    }, (err) => {
      this.errMsg = 'Nije moguće pronaći posetu.';
      console.error(err);
    }); 
    
  }



  checkOut() {
      let visiti = new Visiti();
      visiti.id = this.visit.id;
      visiti.leave = new Date().toISOString();
      this.visitService.editCheckin(visiti).subscribe(res => {
        this.dismissModal();
        location.href = 'admin/manage-visits';
      },(err) => {
        console.error(err);
      });
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  getTimeInside() {
    console.log(this.visit);
    const enter: any = new Date(this.visit.enter);
    const now: any = new Date(new Date().toISOString().slice(0,-1));

    const diffMs = (now - enter); // milliseconds between now & Christmas
    const diffDays = Math.floor(diffMs / 86400000); // days
    const diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    const hrs = diffDays >= 1 ? (diffDays * 24) + diffHrs : diffHrs;
    return `${hrs.toString().length === 1 ? '0' : ''}${hrs}:${diffMins.toString().length === 1 ? '0' : ''}${diffMins}`
  }

}
